import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=0a66f127&scoped=true&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"
import style0 from "./Limit.vue?vue&type=style&index=0&id=0a66f127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66f127",
  null
  
)

export default component.exports